// extracted by mini-css-extract-plugin
module.exports = {"global-freight-summit":"GlobalFreightSummit_global-freight-summit__QLxrV"};